import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

import ReactLoading from 'react-loading';

function Loading() {
  return <ReactLoading { ...loadingStyle } />;
}

const loadingStyle = {
  color: "#20a8d8",
  height: 200,
  width: 150,
  type: 'bubbles'
};

const Logs = Loadable({
  loader: () => import('./views/Logs'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const User = Loadable({
  loader: () => import('./views/Users/User'),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/logs', name: 'Logs', component: Logs },
  { path: '/users', exact: true,  name: 'Users', component: Users },
  { path: '/users/:id', exact: true, name: 'User Details', component: User },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js